export default "__VITE_ASSET__CRwWyjFI__"